// extracted by mini-css-extract-plugin
export default {"infoTable":"hcx-card-summary-stats_infoTable__uwlZx","switcherWrapper":"hcx-card-summary-stats_switcherWrapper__hY8VZ"};